import { baseURL } from "@repo/helpers";
import { CirclePaint, LineLayout, LinePaint } from "mapbox-gl";

const ALLOWED_PATTERNS = [
  "hiking-line-pattern",
  "biking-line-pattern",
] as const;

type ALLOWED_PATTERN = (typeof ALLOWED_PATTERNS)[number];

export const MAP_CENTER = {
  latitude: 56.350012,
  longitude: 9.075583,
  zoom: 6,
};

export type CustomPatterns = Omit<LinePaint, "line-pattern"> & {
  "line-pattern": ALLOWED_PATTERN;
};

export const LINE_LAYOUT: LineLayout = {
  "line-join": "round",
  "line-cap": "round",
};

interface PATTERN {
  key: ALLOWED_PATTERN;
  src: string;
}

export const PATTERNS: PATTERN[] = [
  {
    key: "hiking-line-pattern",
    src: `${baseURL()}/assets/hiking-line-pattern.png`,
  },
  {
    key: "biking-line-pattern",
    src: `${baseURL()}/assets/biking-line-pattern.png`,
  },
];

export const BIKING_LINE_PAINT: CustomPatterns = {
  "line-pattern": "biking-line-pattern",
  "line-color": "#FA6732",
  "line-width": 5,
};

export const BIKING_LINE_PAINT_FALLBACK: LinePaint = {
  "line-color": "#FA6732",
  "line-width": 5,
};

export const BIKING_LOOP_LINE_PAINT_FALLBACK: LinePaint = {
  "line-color": "#4BC964",
  "line-width": 5,
};

export const WALKING_LOOP_LINE_PAINT_FALLBACK: LinePaint = {
  "line-color": "#602A65",
  "line-width": 5,
};

export const NAVIGATION_LINE_PAINT: LinePaint = {
  "line-color": "rgb(14, 82, 254)",
  "line-width": 5,
  "line-dasharray": [0, 2],
};

export const WALKING_LINE_PAINT_FALLBACK: LinePaint = {
  "line-color": "#FAD248",
  "line-width": 5,
};

export const WALKING_LINE_PAINT: CustomPatterns = {
  "line-pattern": "hiking-line-pattern",
  "line-color": "#FAD248",
  "line-width": 5,
};

export const OUTLINE_PAINT: LinePaint = {
  "line-color": "#773610",
  "line-width": 1,
  "line-gap-width": 5,
};

export const INTERACTIVE_AREA_LINE_PAINT: LinePaint = {
  "line-opacity": 0,
  "line-width": 35,
};

export const START_END_POINT_PAINT: CirclePaint = {
  "circle-color": "#FFFFFF",
  "circle-stroke-color": "#773610",
  "circle-stroke-width": 1,
  "circle-radius": 4,
};

export const HOVER_POINT_PAINT: CirclePaint = {
  "circle-color": "#2652F5",
  "circle-stroke-width": 1,
  "circle-stroke-color": "#1525EB",
  "circle-radius": 6,
};

export const FACILITY_CLUSTER_OPTIONS = { radius: 50, maxZoom: 30 };

export const ZOOM_ANIMATION_OPTIONS = {
  padding: 75,
  duration: 1000,
};

export const MAX_CLUSTER_ZOOM = 20;

export const MAP_STYLE = "mapbox://styles/mapbox/streets-v12";

export const MAP_SCALE_STYLE = {
  backgroundColor: "transparent",
  border: "none",
  borderBottom: "2px solid #333",
  marginTop: "48px",
};

export const DISTANCE_CALCULATION_TIME_THRESHOLD = 300;
